import uk from '../langs/drPropertyPanel/uk.json'
import ru from '../langs/drPropertyPanel/ru.json'
import en from '../langs/drPropertyPanel/en.json'

export default {
  computed: {
    items() {
      return [
        {name: this.$t('drPropertyPanel.widgets'), value: 0},
        {name: this.$t('drPropertyPanel.properties'), value: 1}
      ]
    }
  },
  i18n: {
    messages: {
      uk,
      en,
      ru
    }
  }
}
